<template>
  <el-col v-bind="$props">
    <slot />
  </el-col>
</template>

<script>
export default {
  name: 'RtCol',
  props: {
    span: {
      type: Number,
      default: 24
    },
    tag: {
      type: String,
      default: 'div'
    },
    offset: Number,
    pull: Number,
    push: Number,
    xs: [Number, Object],
    sm: [Number, Object],
    md: [Number, Object],
    lg: [Number, Object],
    xl: [Number, Object]
  }
};
</script>



// WEBPACK FOOTER //
// rtCol.vue?41b8bd32